import { render, staticRenderFns } from "./ReportsTitle.vue?vue&type=template&id=49ca4768&"
import script from "./ReportsTitle.vue?vue&type=script&lang=js&"
export * from "./ReportsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports